import { orderBy } from 'lodash-es'

import { IRichAttendee } from '../attendee/types'

export function sortRichAttendees(attendees: IRichAttendee[]): IRichAttendee[] {
  return orderBy(
    attendees,
    [
      // Sort guest roles above teammates
      (attendee) => attendee.role === 'guest',
      // Attendees with company go first
      (attendee) => !!attendee.company,
      // Same company together
      (attendee) => attendee.company?.name,
      // Prefer job_title and at least one of LinkedIn and CRM
      (attendee) => !!attendee.job_title && (!!attendee.linkedin_url || attendee.crms?.length > 0),
      // Prefer job_title or LinkedIn or CRM
      (attendee) => !!attendee.job_title || !!attendee.linkedin_url || attendee.crms?.length > 0,
      'name',
      'email',
    ],
    ['desc', 'desc', 'asc', 'desc', 'desc', 'asc', 'asc']
  )
}
